import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function AutoCode ( props ) {

    return <BasicCrudScreenType id="AutoCode" table="AutoCode" view="VwAutoCode" />;

}

export default AutoCode;
